import React from "react";
import DemoPopup from "@components/organisms/bookingpage-demo/DemoPopup";
import ResponsiveImage from "@components/atoms/image/ResponsiveImage";

type DescriptionProps = {
  data: string[];
};

const Description = ({ data }: DescriptionProps) => {
  return (
    <>
      {data.map((item, count) => (
        <p
          className="lg:mb-5"
          dangerouslySetInnerHTML={{ __html: item }}
          key={count}
        />
      ))}
    </>
  );
};

type ImageProps = {
  data: {
    title: string;
    desc: string[];
    cta: {
      id: string;
      text: string;
      href: string;
    }[];
    image: {
      src: string;
      alt: string;
      prefixes: {
        dpi: string;
      };
    };
  };
  className?: string;
};

const ImageLeft = ({ data, className }: ImageProps) => {
  return (
    <div
      className={`container grid--default has-align-middle md:pb-10 lg:pb-15 ${
        className ? className : ""
      }`}
    >
      <ResponsiveImage
        width="560"
        height="400"
        imgClass="img-fit md:w-100"
        wrapClass="lg:maxw-lg"
        src={data.image.src}
        alt={data.image.alt}
        dpi={data.image.prefixes.dpi}
        hasMobileImg={false}
      />{" "}
      <article className="text-left lg:maxw-3xl lg:pl-10">
        <h2
          className="text-lg lg:mb-3 md:mb-2 md:mt-5"
          dangerouslySetInnerHTML={{ __html: data.title }}
        />
        <Description data={data.desc} />
        <DemoPopup data={data.cta} />
      </article>
    </div>
  );
};

const ImageRight = ({ data, className }: ImageProps) => {
  return (
    <div
      className={`container grid--default has-align-middle md:pb-10 lg:pb-15 md:fx md:fx--w ${className}`}
    >
      <article className="text-left lg:maxw-3xl lg:pr-10 fx--o-2">
        <h2
          className="text-lg lg:mb-3 md:mb-2 md:mt-5"
          dangerouslySetInnerHTML={{ __html: data.title }}
        />
        <Description data={data.desc} />
        <DemoPopup data={data.cta} />
      </article>{" "}
      <ResponsiveImage
        width="560"
        height="400"
        imgClass="img-fit md:w-100"
        wrapClass="lg:maxw-lg"
        src={data.image.src}
        alt={data.image.alt}
        dpi={data.image.prefixes.dpi}
        hasMobileImg={false}
      />
    </div>
  );
};

type FeaturedImageProps = {
  data: {
    title: string;
    desc: string[];
    cta: {
      id: string;
      text: string;
      href: string;
    }[];
    image: {
      src: string;
      alt: string;
      prefixes: {
        dpi: string;
      };
    };
  }[];
  imageAlign: "left" | "right";
  className?: string;
};

const FeaturedImage = ({ data, imageAlign }: FeaturedImageProps) => {
  return (
    <>
      {Array.isArray(data) ? (
        data.map((item, count) =>
          imageAlign === "left" ? (
            <ImageLeft data={item} key={count} />
          ) : (
            <ImageRight data={item} key={count} />
          )
        )
      ) : imageAlign === "left" ? (
        <ImageLeft data={data} />
      ) : (
        <ImageRight data={data} />
      )}
    </>
  );
};

export default FeaturedImage;
